import apiService from '../../services/ApiService';
import configuration from '../../constants/Configuration';
import appParameters from '../../components/utils/AppParameters';
import apiServiceUtils from '../../components/utils/ApiServiceUtils';
import storeManager from '../../store/StoreManager';
import { hideMenus, refreshThemeSelector, showMainUniverse, showSavePreloader } from '../../actions/MenuActions';
import clipartParserJSONNew from '../accordion/clipartUtils/ClipartParserJSONNew';
import universesData from '../../../docs/universesList';
import themesData from '../../../docs/themesList';
import videoThemesList from '../../../docs/videoThemesList';
import newTheme from '../../../docs/newTheme';
import newThemeReloaded from '../../../docs/newThemeReloaded';
import videoUtils from './VideoUtils';
import menuType from '../../constants/MenuType';
import clipartVideoModel from '../../../docs/video_italy';
import videoClipartParserJSON from '../accordion/clipartUtils/VideoClipartParserJSON';


const masterUniverseUtils = {
    universesArray: [],
    themesArray: [],
    videoThemesArray: [],
    scrollPosition: 0,

    useThumbnailsLazyLoading(usePagination = false) {
        if (usePagination)
            return false;
        else
            return true;
    },
    language() {
        return appParameters.locale;
    },
    getMainUniversesList() {
        return this.universesArray;
    },
    getCurrentUniverseTitle() {
        if (appParameters.currentMainUniverse == '')
            return '';

        var universeItem = this.universesArray[appParameters.currentMainUniverse];

        if (universeItem) {
            if (!universeItem.translations)
                return universeItem.universe;
            else {
                var translation = universeItem.translations[this.language()];

                if (translation && translation.length > 0)
                    return translation;
                else if (universeItem.translations['en_US'])
                    return universeItem.translations['en_US'];
                else
                    return universeItem.universe;
            }
        } else
            return '';
    },
    checkCurrentUniverse() {
        if (appParameters.currentTheme != '' && appParameters.currentMainUniverse == '') {
            for (var universe in this.themesArray) {
                var themes = this.themesArray[universe];

                for (var i=0; i<themes.length; i++) {
                    if (appParameters.currentTheme == themes[i].name) {
                        appParameters.currentMainUniverse = universe;
                        return;
                    }
                }
            }
        }
    },
    getCurrentThemes() {
        if (appParameters.currentMainUniverse == '')
            return [];

        return this.themesArray[appParameters.currentMainUniverse];
    },
    getAllThemes() {
        var themes = [];

        for (var universe in this.universesArray) {
            themes = themes.concat(this.themesArray[universe]);
        }

        for (var i=0; i<themes.length; i++) {
            themes[i].currentTitle = this.getCurrentTitle(themes[i]);
        }

        themes = this.sortElementsByCurrentTitle(themes);

        return themes;
    },
    getCurrentTitle(theme) {
        if (!theme.translations)
            return theme.name;
        else {
            var translation = theme.translations[this.language()];

            if (translation && translation.length > 0)
                return translation;
            else if (theme.translations['en_US'])
                return theme.translations['en_US'];
            else
                return theme.name;
        }
    },
    sortElementsByCurrentTitle(array) {
        array.sort(function(a, b){
            if (a.currentTitle < b.currentTitle)
                return -1;
            if (a.currentTitle > b.currentTitle)
                return 1;

            return 0;
        });

        return array;
    },
    getCurrentThemeTitle() {
        if (appParameters.currentMainUniverse == '' || appParameters.currentTheme == '')
            return '';

        var array = this.themesArray[appParameters.currentMainUniverse];

        for (var i=0; i<array.length; i++) {
            if (array[i].name == appParameters.currentTheme) {
                var translation = array[i].translations[this.language()];

                if (translation && translation.length > 0)
                    return translation;
                else if (array[i].translations['en_US'])
                    return array[i].translations['en_US'];
                else
                    return array[i].name;
            }
        }

        return '';
    },
    goToTheme(themeName) {
        if (!themeName || appParameters.currentTheme == themeName)
            return;

        this.changeTheme(themeName);

        var dispatch = storeManager.getStore().dispatch;
        dispatch(refreshThemeSelector());
    },
    loadCartoonistEffects() {
        if (configuration.LOAD_LOCAL)
            return;

        if (clipartParserJSONNew.cartoonistEffects)
            return;

        apiService.loadThemesFromUniverse('common').then(response => {
            var commonThemes = response;
            var effectsTheme;

            for (var i=0; i<commonThemes.length; i++) {
                if (commonThemes[i].name.indexOf('effects') != -1)
                    effectsTheme = commonThemes[i];
            }

            if (!effectsTheme)
                return;

            var themeName = this.getCurrentTitle(effectsTheme);

            apiService.loadCurrentTheme(effectsTheme.name).then(response => {
                clipartParserJSONNew.parseClipartModel(response, true, themeName);
            });
        });
    },
    loadTheme() {
        this.loadCartoonistEffects();
        this.loadUniversesAndThemes();
        this.loadVideoThemes();

        if (appParameters.currentTheme.length < 1) {
            clipartParserJSONNew.addClipartModelHandler({items:[], captionKey: appParameters.currentTheme});
            return;
        }

        if (configuration.LOAD_LOCAL)
            clipartParserJSONNew.parseClipartModel(JSON.parse(newTheme.data));
        else
            this.executeGetThemeCall();
    },
    reloadTheme() {
        if (configuration.LOAD_LOCAL)
            clipartParserJSONNew.parseClipartModel(JSON.parse(newThemeReloaded.data));
        else
            this.executeGetThemeCall();
    },
    getLocaleParameter() {
        if (appParameters.currentMainUniverse == 'alphabet_planet') {
            if (appParameters.locale == 'nn_NO' || appParameters.locale == 'nb_NO' || appParameters.locale == 'sv_SE') {
                return appParameters.locale;
            } else
                return '';
        }

        return '';
    },
    executeGetThemeCall() {
        if (!appParameters.currentTheme || appParameters.currentTheme == '')
            return;

        this.showPreloader(true);
        apiServiceUtils.executeSafeApiCall(function() {
            apiService.loadCurrentTheme(appParameters.currentTheme, this.getLocaleParameter()).then(response => {
                clipartParserJSONNew.parseClipartModel(response);

                this.showPreloader(false);
                storeManager.getStore().dispatch(hideMenus([menuType.UNIVERSES_MENU]));
            });
        }.bind(this));
    },
    showPreloader(value) {
        var dispatch = storeManager.getStore().dispatch;
        dispatch(showSavePreloader(value));
    },
    loadUniversesAndThemes() {
        if (configuration.LOAD_LOCAL) {
            var array = JSON.parse(universesData.data);
            this.parseUniverses(array);

            array = JSON.parse(themesData.data);
            this.parseThemes(array);
        } else {
            this.executeGetUniversesCall();
            this.executeGetThemesCall();
        }
    },
    isSpecialOrganization: false,
    isDemoUser() {
        if (this.isSpecialOrganization)
            return true;
        
        var testUsers = [15682463, 54719315, 54829736, 54829790, 54829795, 54829800, 110850418, 111170430];
        var isTestUser = false;

        if (!configuration.IS_PROD() || configuration.LOAD_LOCAL || (configuration.IS_PROD() && testUsers.indexOf(appParameters.currentUserId) != -1))
            isTestUser  = true;

        return isTestUser;
    },
    parseUniverses(array) {
        var demoUniverses = ['alphabet_planet'];
        var isDemo = this.isDemoUser();

        for (var i=0; i<array.length; i++) {
            var universeName = array[i].universe;

            if (isDemo) {
                this.universesArray[universeName] = array[i]; // add all universes
            } else { // regular user
                if (demoUniverses.indexOf(universeName) == -1)
                    this.universesArray[universeName] = array[i];
            }
        }

        this.checkCurrentUniverse();

        var dispatch = storeManager.getStore().dispatch;
        dispatch(refreshThemeSelector());
    },
    parseThemes(array) {
        this.themesArray = this.getCategories(this.filterThemes(array));
        this.checkCurrentUniverse();
    },
    filterThemes(array) {
        var isNorway = (appParameters.locale == 'nb_NO' || appParameters.locale == 'nn_NO') ? true : false;
        var isSwedish = (appParameters.locale == 'sv_SE') ? true : false;
        var removedThemes = [];
        var newArray = [];

        if (!isNorway && !isSwedish) {
            removedThemes = ['norge_i_dag', 'sverige_i_dag', 'elements_molecules_swe'];
        } else {
            if (isNorway)
                removedThemes = ['sverige_i_dag', 'elements_molecules_swe', 'ae_s_theme', 'oe_s_theme'];
            else
                removedThemes = ['norge_i_dag', 'elements_molecules', 'ae_theme', 'oe_theme'];
        }

        for (var i=0; i<array.length; i++) {
            if (removedThemes.indexOf(array[i].name) == -1)
                newArray.push(array[i]);
        }

        return newArray;
    },
    getCategories(array) {
        var universesMap = [];

        for (var i=0; i<array.length; i++) {
            var universe = array[i].universe;

            if (!universesMap[universe])
                universesMap[universe] = [];

            universesMap[universe].push(array[i]);
        }

        for (var key in universesMap) {
            universesMap[key] = this.sortElementsByPosition(universesMap[key]);
        }

        return universesMap;
    },
    sortElementsByPosition(array) {
        array.sort(function(a, b){return a.position - b.position});

        return array;
    },
    executeGetUniversesCall() {
        apiServiceUtils.executeSafeApiCall(function() {
            apiService.loadUniverses().then(response => {
                this.parseUniverses(response)
            });
        }.bind(this));
    },
    executeGetThemesCall() {
        apiServiceUtils.executeSafeApiCall(function() {
            apiService.loadThemes().then(response => {
                this.parseThemes(response);
            });
        }.bind(this));
    },
    changeMainUniverse(universe) {
        appParameters.currentMainUniverse = universe;
        appParameters.currentTheme = '';

        var dispatch = storeManager.getStore().dispatch;
        dispatch(showMainUniverse(false));
    },
    changeTheme(theme) {
        videoUtils.browserActiveButton = 0;
        appParameters.currentTheme = theme;
        appParameters.currentMainUniverse = '';
        this.checkCurrentUniverse();

        this.reloadTheme();
    },


    getCurrentVideoThemes() {
        return this.videoThemesArray;
    },
    loadVideoThemes() {
        if (configuration.LOAD_LOCAL) {
            this.videoThemesArray = this.getAllVideoThemes();
        } else {
            this.executeGetVideoThemesCall();
        }
    },
    getAllVideoThemes(themes) {
        var allVideoThemes;
        var theme;
        var i;

        if (themes)
            allVideoThemes = themes;
        else
            allVideoThemes = JSON.parse(videoThemesList.data);

        for (i=0; i<allVideoThemes.length; i++) {
            theme = allVideoThemes[i];

            theme.isAvailable = true;
            theme.href = 'https://s3.amazonaws.com/creaza-clipart/staticthumbs/master_universes/' + theme.name + '.jpg';
            theme.title = this.getCurrentTitle(theme);
        }

        return allVideoThemes;
    },
    executeGetVideoThemesCall() {
        apiServiceUtils.executeSafeApiCall(function() {
            apiService.listVideoThemes().then(response => {
                this.videoThemesArray = this.getAllVideoThemes(response);
            });
        }.bind(this));
    },
    reloadVideoClipart() {
        if (configuration.LOAD_LOCAL == false) {
            apiServiceUtils.executeSafeApiCall(this.executeReloadVideoClipart.bind(this));
        } else {
            videoClipartParserJSON.parseClipartModel(JSON.parse(clipartVideoModel.data));
        }

        videoUtils.browserActiveButton = 0;
    },
    executeReloadVideoClipart() {
        if (!appParameters.currentVideoTheme || appParameters.currentVideoTheme == '')
            return;

        this.showPreloader(true);
        apiService.loadVideoTheme(appParameters.currentVideoTheme).then(response => {
            videoClipartParserJSON.parseClipartModel(response);

            this.showPreloader(false);
            storeManager.getStore().dispatch(hideMenus([menuType.UNIVERSES_MENU]));
        });
    },
    changeVideoTheme(theme) {
        videoUtils.browserActiveButton = 0;
        appParameters.currentVideoTheme = theme;

        this.reloadVideoClipart();
    },
    autoselectClipart(clipartCategory) {
        if (clipartCategory == 0) // go to Cartoonist tab
            this.changeTheme(appParameters.currentTheme);
        else
        if (clipartCategory == 1) // go to Video tab
            this.changeVideoTheme(appParameters.currentVideoTheme);
    },
    getCurrentVideoThemeTitle() {
        if (appParameters.currentVideoTheme == '')
            return '';

        var array = this.videoThemesArray;

        for (var i=0; i<array.length; i++) {
            if (array[i].name == appParameters.currentVideoTheme)
                return array[i].title;
        }

        return '';
    }
};

export default masterUniverseUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/MasterUniverseUtils.js
 **/